import Api from "./Api";

export default {

    getSeatLayout(payload) {
        return Api().get(`/api/rts/seat-layout/${payload.rts_performance_id}`);
    },

    reserveSeats(payload) {
        return Api().post(`/api/rts/reserve-seats/${payload.rts_performance_id}`, payload);
    },

    makeRtsPayment(payload) {
        return Api().post(`/api/cinema/braintree/pay-rts`, payload);
    },

    getReservationDetails(payload) {
        return Api().get(`/api/rts/reserve-details/${payload.reserve_id}`);
    },

    getBookingDetails(payload) {
        return Api().get(`/api/rts/book-details/${payload.reserve_id}`);
    },

}


// WEBPACK FOOTER //
// ./src/services/rtsServices.js